import axios from "axios";
import toast from "react-hot-toast";
import { store } from "../redux/store";
import { logout } from "../redux/reducers/authSlice";

export const appServiceName = process.env.REACT_APP_WEBSITE_URL;


/*
|--------------------------------------------------------------------------
| Axios Instance
|--------------------------------------------------------------------------
*/

const http = axios.create({
  baseURL: appServiceName,

  headers: {
    Accept: "application/json",
  },
});


/*
|--------------------------------------------------------------------------
| REQUEST INTERCEPTOR
|--------------------------------------------------------------------------
| Har API request ke saath Passport Bearer token jayega
|--------------------------------------------------------------------------
*/

http.interceptors.request.use(
  (config) => {

    const token = localStorage.getItem("token");

    if (token) {

      config.headers = config.headers || {};

      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },

  (error) => {
    return Promise.reject(error);
  }
);


/*
|--------------------------------------------------------------------------
| RESPONSE INTERCEPTOR
|--------------------------------------------------------------------------
*/

http.interceptors.response.use(

  (response) => {
    return response;
  },

  (error) => {

    if (error.response?.status === 401) {

      /*
      |--------------------------------------------------------------------------
      | Token invalid / expired
      |--------------------------------------------------------------------------
      */

      localStorage.removeItem("token");

      store.dispatch(logout());

      toast.error("Session expired. Please login again.");

      /*
      |--------------------------------------------------------------------------
      | Do NOT use navigate()
      | because this file is outside React component
      |--------------------------------------------------------------------------
      */

      window.location.href = "/";
    }

    return Promise.reject(error);
  }
);


/*
|--------------------------------------------------------------------------
| Restful Provider
|--------------------------------------------------------------------------
*/

const RestfulProvider = {

  /*
  |--------------------------------------------------------------------------
  | GET
  |--------------------------------------------------------------------------
  */

  get: (url, params = {}) => {

    return http
      .get(url, {
        params: params,
      })
      .then((res) => res.data);
  },


  /*
  |--------------------------------------------------------------------------
  | POST
  |--------------------------------------------------------------------------
  */

  post: async (url, data = {}) => {

    const isFormData = data instanceof FormData;

    const res = await http.post(
      url,
      data,
      {
        headers: isFormData
          ? {}
          : {
              "Content-Type": "application/json",
            },
      }
    );

    return res.data;
  },


  /*
  |--------------------------------------------------------------------------
  | PUT
  |--------------------------------------------------------------------------
  */

  put: async (url, data = {}) => {

    const res = await http.put(
      url,
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  },


  /*
  |--------------------------------------------------------------------------
  | DELETE
  |--------------------------------------------------------------------------
  */

  delete: async (url, data = {}) => {

    const res = await http.delete(
      url,
      {
        data: data,
      }
    );

    return res.data;
  },
};


export default RestfulProvider;

